import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ElementRef,
  Renderer2,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';

import {ProjectService} from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';

import {
  ProjectActivityService
} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity.service';
import {ProjectActivity} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity';
import * as _ from 'underscore';

import {OverlayPanel} from 'primeng/overlaypanel';
import {timer, Subject, Subscription} from 'rxjs';
import * as moment from 'moment';
import {MatDialog} from '@angular/material/dialog';
import {ProjectWindowComponent} from '../../project/view/project-window/project-window.component';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {filter, debounceTime, distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {DeviceDetectorService} from 'ngx-device-detector';

import {ProjectInfoComponent} from 'projects/mobile/src/app/modules/project/view/project-info/project-info.component';
import {User} from 'projects/core/src/lib/login/data/user';
import {AppStateQuery} from '../../../data/app-state.query';
import {
  PdfPreviewDialogComponent
} from 'projects/app-misc/src/app/modules/project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';
import {WsService} from '../../../../../../app-misc/src/app/modules/data/ws.service';
import {WsUpdateResponce} from '../../../../../../app-misc/src/app/modules/data/ws-update-responce';
import {ShortProject} from '../../../../../../app-misc/src/app/modules/project-misc/data/project/short-project';
import {RouterService} from '../../../../../../core/src/lib/misc/router/router.service';
import {ConfirmationService} from 'primeng/api';
import {MiscSnackBarService} from '../../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {UsersService} from '../../../../../../app-misc/src/app/modules/users/data/users.service';
import {LocalStorage} from 'ngx-webstorage';

interface ScheduledActivity {
  activity: ProjectActivity;
  rowIndex: number;
  overlaps: boolean;
}

@Component({
  selector: 'app-user-schedule',
  templateUrl: './user-schedule.component.html',
  styleUrls: ['./user-schedule.component.scss'],
  providers: [
    DeviceDetectorService,
    ConfirmationService
  ]
})
@RxJSUnsubscribe
export class UserScheduleComponent implements OnInit, AfterViewInit, OnDestroy, RxJSUnsubscribable {

  @ViewChild('scheduleContent', {static: true})
  scheduleContent: ElementRef<HTMLDivElement>;

  @ViewChild('deleteDropArea', {static: false})
  deleteDropArea: ElementRef<HTMLDivElement>;

  @ViewChild('eventHintOP', {static: true})
  eventHintOP: OverlayPanel;

  loadingEvents = true;
  loadingUsers = true;
  loadingPastEvents = false;
  loadingFutureEvents = false;

  users: User[] = [];
  activities: ProjectActivity[] = [];
  userActivities: Map<number, ScheduledActivity[]> = new Map();
  unassignedActivities: ScheduledActivity[] = [];
  userRowHeights: Map<number, number> = new Map();
  unassignedRowHeight = 80;
  activityIdMap: Map<number, ProjectActivity[]> = new Map();

  readonly rowHeight = 40;
  readonly minRowHeight = 80;

  activityTypes: any[] = [];
  installationTypeId: number;
  selectedTypeIds: number[] = [];
  selectedUserIds: number[] = [];
  allUsersCache: User[] = [];
  showUnassigned = true;
  showWeekends = true;

  activityInHint: ProjectActivity;

  isTablet = false;
  isMobile = false;

  startDate: moment.Moment;
  endDate: moment.Moment;

  currentUser: User;

  wsSocketSub: Subscription;

  private lastClickTime = 0;
  private lastClickedEventId: string = null;
  private doubleClickDelay = 300;
  private singleClickTimeout: any = null;

  private lastTouchTime = 0;
  private lastTouchedEventId: string = null;

  days: Date[] = [];

  @LocalStorage('fc_user_schedule_dayWidth', 100)
  dayWidth;

  isDragging = false;
  wasDragging = false;
  hasLoadedDuringDrag = false;
  startX = 0;
  scrollLeft = 0;

  private scrollThreshold = 200;

  draggedActivity: ProjectActivity = null;
  draggedOriginalUser: User | null = null;
  dragOffsetX = 0;
  dragOffsetY = 0;
  isDraggingEvent = false;
  isDraggingUser = false;

  private dragStartTimer: any = null;
  private pendingDragActivity: ProjectActivity = null;
  private pendingDragElement: HTMLElement = null;
  private dragStartXEvent = 0;
  private dragStartYEvent = 0;

  dragPreviewElement: HTMLElement = null;
  dragPreviewX = 0;
  dragPreviewY = 0;
  draggedOriginalElement: HTMLElement = null;
  highlightedDayIndex = -1;
  highlightedUserId = -1;
  highlightedUnassigned = false;
  autoScrollInterval: any = null;
  autoScrollSpeed = 0;

  isSplitMode = false;
  splitActivity: ProjectActivity = null;
  hoveredSplitGuideIndex = -1;
  snapThreshold = 20;

  draggedUser: User = null;
  draggedUserIndex = -1;
  dropTargetUserIndex = -1;
  draggedUserHeight = 0;
  userDragPreviewElement: HTMLElement = null;
  isOverDeleteArea = false;

  constructor(
    protected wsService: WsService,
    protected appStateQuery: AppStateQuery,
    protected dialog: MatDialog,
    protected projectService: ProjectService,
    protected confirmationService: ConfirmationService,
    protected projectActivityService: ProjectActivityService,
    protected deviceDetectorService: DeviceDetectorService,
    protected miscSnackBarService: MiscSnackBarService,
    protected elementRef: ElementRef,
    protected renderer: Renderer2,
    protected routerService: RouterService,
    protected usersService: UsersService,
    protected cdr: ChangeDetectorRef
  ) {
    this.isTablet = this.deviceDetectorService.isTablet();
    this.isMobile = this.deviceDetectorService.isMobile();
  }

  ngOnInit() {
    this.appStateQuery.currentUser$.subscribe(currentUser => this.currentUser = currentUser);

    this.startDate = moment().subtract(1, 'week').startOf('day');
    this.endDate = moment().add(1, 'month').endOf('day');

    this.generateDays();
    this.loadActivityTypes();
    this.wsSub();
  }

  generateDays() {
    this.days = [];
    const start = moment(this.startDate);
    const end = moment(this.endDate);

    for (const m = moment(start); m.isBefore(end); m.add(1, 'days')) {
      this.days.push(m.toDate());
    }
  }

  prependDays(daysToAdd: number): number {
    const newDays: Date[] = [];
    const newStart = moment(this.startDate).subtract(daysToAdd, 'days');

    for (const m = moment(newStart); m.isBefore(this.startDate); m.add(1, 'days')) {
      newDays.push(m.toDate());
    }

    this.days = [...newDays, ...this.days];
    return newDays.length;
  }

  appendDays(daysToAdd: number) {
    const start = moment(this.endDate).add(1, 'days').startOf('day');
    const end = moment(this.endDate).add(daysToAdd, 'days').endOf('day');

    for (const m = start; m.isBefore(end); m.add(1, 'days')) {
      this.days.push(m.toDate());
    }
  }

  trimDates(direction: 'past' | 'future'): number {
    const diffDays = this.endDate.diff(this.startDate, 'days');
    const maxDays = 60;

    if (diffDays <= maxDays) return 0;

    if (direction === 'past') {
      // Loaded past, trim future
      const newEndDate = moment(this.startDate).add(maxDays, 'days').endOf('day');

      this.days = this.days.filter(d => moment(d).isSameOrBefore(newEndDate));
      this.endDate = newEndDate;

      this.activities = this.activities.filter(a => moment(a.startDate).isSameOrBefore(this.endDate));
      return 0;
    } else {
      // Loaded future, trim past
      const newStartDate = moment(this.endDate).subtract(maxDays, 'days').startOf('day');

      const daysToRemove = this.days.filter(d => moment(d).isBefore(newStartDate));
      const removedWidth = daysToRemove.length * this.dayWidth;

      this.days = this.days.filter(d => moment(d).isSameOrAfter(newStartDate));
      this.startDate = newStartDate;

      this.activities = this.activities.filter(a => moment(a.endDate).isSameOrAfter(this.startDate));

      return removedWidth;
    }
  }

  loadActivityTypes() {
    this.projectActivityService.getActivityTypes().subscribe(types => {
      this.activityTypes = types;
      const installationType = types.find(t => t.name === 'Installation');
      if (installationType) {
        this.installationTypeId = installationType.id;
        this.selectedTypeIds = [this.installationTypeId];
        this.fetchUsersForTypes([this.installationTypeId]);
      }
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message);
    });
  }

  fetchUsersForTypes(typeIds: number[]) {
    const typeNames: string[] = [];
    if (this.activityTypes.length > 0) {
      this.activityTypes.forEach(t => {
        if (typeIds.includes(t.id)) {
          typeNames.push(t.name);
        }
      });
    }

    if (typeNames.length === 0) return;

    this.loadingUsers = true;
    this.usersService.getUsersByActivityTypes(typeNames.join(',')).subscribe(users => {
      this.allUsersCache = users;
      this.loadingUsers = false;
      this.applyUserFilter();
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message);
      this.loadingUsers = false;
    });
  }

  onUsersFilterChange(userIds: number[]) {
    this.selectedUserIds = userIds;
    this.applyUserFilter();
  }

  changeDayWidth(delta: number) {
    const newWidth = this.dayWidth + delta;
    if (newWidth >= 60 && newWidth <= 160) {
      const container = this.scheduleContent.nativeElement;
      const scrollLeft = container.scrollLeft;
      const clientWidth = container.clientWidth;
      const centerPixel = scrollLeft + (clientWidth / 2);
      const centerDayIndex = centerPixel / this.dayWidth;

      this.dayWidth = newWidth;

      setTimeout(() => {
        const newCenterPixel = centerDayIndex * newWidth;
        container.scrollLeft = newCenterPixel - (clientWidth / 2);
      });
    }
  }

  applyUserFilter() {
    if (!this.allUsersCache) return;

    if (this.selectedUserIds && this.selectedUserIds.length > 0) {
      this.users = this.allUsersCache.filter(u => this.selectedUserIds.includes(u.id));
      this.users.sort((a, b) => (a.installationPosition || 0) - (b.installationPosition || 0));
      this.showUnassigned = this.selectedUserIds.includes(-1);
    } else {
      this.users = [];
      this.showUnassigned = false;
    }
    this.loadActivities();
  }

  scrollToToday() {
    this.startDate = moment().subtract(1, 'week').startOf('day');
    this.endDate = moment().add(1, 'month').endOf('day');
    this.generateDays();

    this.loadActivities();

    setTimeout(() => {
      const today = moment().startOf('day');
      const index = this.days.findIndex(d => moment(d).isSame(today, 'day'));

      if (index >= 0 && this.scheduleContent) {
        const container = this.scheduleContent.nativeElement;
        const containerWidth = container.clientWidth;
        const scrollPos = (index * this.dayWidth) - (containerWidth / 2) + (this.dayWidth / 2);

        container.scrollLeft = scrollPos;
        this.scrollLeft = scrollPos;
      }
    });
  }

  loadActivities() {
    if ((!this.selectedTypeIds || this.selectedTypeIds.length === 0) && !this.installationTypeId) return;
    if (this.loadingUsers) return;

    this.loadingEvents = true;
    const dateFrom = this.startDate.toDate();
    const dateTo = this.endDate.toDate();
    const typeIds = this.selectedTypeIds.length > 0 ? this.selectedTypeIds : [this.installationTypeId];

    const userIds = this.users.map(u => u.id);
    if (this.showUnassigned) {
      userIds.push(-1);
    }

    this.projectActivityService.getActivityProjects(dateFrom, dateTo, typeIds, userIds).subscribe(activities => {
      this.activities = activities;
      this.extendTimeRangeIfNeeded();
      this.loadingEvents = false;
      this.distributeActivities();
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message);
      this.loadingEvents = false;
    });
  }

  loadPastActivities() {
    if (this.loadingPastEvents || (!this.installationTypeId && this.selectedTypeIds.length === 0)) return;

    this.loadingPastEvents = true;
    const daysToLoad = 14;
    const newStartDate = moment(this.startDate).subtract(daysToLoad, 'days');
    const dateFrom = newStartDate.toDate();
    const dateTo = moment(this.startDate).subtract(1, 'days').toDate();
    const typeIds = this.selectedTypeIds.length > 0 ? this.selectedTypeIds : [this.installationTypeId];
    const userIds = this.users.map(u => u.id);
    if (this.showUnassigned) {
      userIds.push(-1);
    }

    this.projectActivityService.getActivityProjects(dateFrom, dateTo, typeIds, userIds).subscribe(activities => {
      const oldScrollLeft = this.scheduleContent.nativeElement.scrollLeft;

      const existingIds = new Set(this.activities.map(a => a.id));
      const newActivities = activities.filter(a => !existingIds.has(a.id));

      this.activities = [...newActivities, ...this.activities];
      const addedDays = this.prependDays(daysToLoad);
      const addedWidth = addedDays * this.dayWidth;
      this.startDate = newStartDate;

      this.trimDates('past');
      this.extendTimeRangeIfNeeded();
      this.distributeActivities();

      this.cdr.detectChanges();

      this.scheduleContent.nativeElement.scrollLeft = oldScrollLeft + addedWidth;

      if (this.isDragging) {
        this.scrollLeft += addedWidth;
      }

      this.loadingPastEvents = false;
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message);
      this.loadingPastEvents = false;
    });
  }

  loadFutureActivities() {
    if (this.loadingFutureEvents || (!this.installationTypeId && this.selectedTypeIds.length === 0)) return;

    this.loadingFutureEvents = true;
    const daysToLoad = 14;
    const dateFrom = moment(this.endDate).add(1, 'days').toDate();
    const newEndDate = moment(this.endDate).add(daysToLoad, 'days');
    const dateTo = newEndDate.toDate();
    const typeIds = this.selectedTypeIds.length > 0 ? this.selectedTypeIds : [this.installationTypeId];
    const userIds = this.users.map(u => u.id);
    if (this.showUnassigned) {
      userIds.push(-1);
    }

    this.projectActivityService.getActivityProjects(dateFrom, dateTo, typeIds, userIds).subscribe(activities => {
      const existingIds = new Set(this.activities.map(a => a.id));
      const newActivities = activities.filter(a => !existingIds.has(a.id));

      this.activities = [...this.activities, ...newActivities];
      this.appendDays(daysToLoad);
      this.endDate = newEndDate;

      this.extendTimeRangeIfNeeded();
      const removedWidth = this.trimDates('future');

      this.distributeActivities();

      if (removedWidth > 0) {
        const currentScrollLeft = this.scheduleContent.nativeElement.scrollLeft;
        this.scheduleContent.nativeElement.scrollLeft = currentScrollLeft - removedWidth;

        if (this.isDragging) {
          this.scrollLeft -= removedWidth;
        }
      }

      this.loadingFutureEvents = false;
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message);
      this.loadingFutureEvents = false;
    });
  }

  extendTimeRangeIfNeeded() {
    let maxEndDate = moment(this.endDate);

    this.activities.forEach(a => {
      const end = moment(a.endDate);
      if (end.isAfter(maxEndDate)) {
        maxEndDate = end;
      }
    });

    if (maxEndDate.isAfter(this.endDate)) {
      const currentEndDay = moment(this.endDate).startOf('day');
      const targetEndDay = moment(maxEndDate).startOf('day');
      const diff = targetEndDay.diff(currentEndDay, 'days');

      if (diff > 0) {
        this.appendDays(diff);
        this.endDate = moment(this.endDate).add(diff, 'days').endOf('day');
      }
    }
  }

  distributeActivities() {
    if (this.loadingUsers || this.loadingEvents) return;

    this.userActivities.clear();
    this.unassignedActivities = [];
    this.userRowHeights.clear();
    this.activityIdMap.clear();

    const rawUserActivities = new Map<number, ProjectActivity[]>();
    this.users.forEach(user => {
      rawUserActivities.set(user.id, []);
    });
    const rawUnassignedActivities: ProjectActivity[] = [];

    this.activities.forEach(activity => {
      if (!this.activityIdMap.has(activity.id)) {
        this.activityIdMap.set(activity.id, []);
      }
      this.activityIdMap.get(activity.id).push(activity);

      if (activity.user && activity.user.id) {
        const list = rawUserActivities.get(activity.user.id);
        if (list) {
          list.push(activity);
        } else {
          rawUnassignedActivities.push(activity);
        }
      } else {
        rawUnassignedActivities.push(activity);
      }
    });

    this.users.forEach(user => {
      const activities = rawUserActivities.get(user.id);
      const processed = this.processOverlaps(activities);
      this.userActivities.set(user.id, processed.activities);
      this.userRowHeights.set(user.id, processed.height);
    });

    const processedUnassigned = this.processOverlaps(rawUnassignedActivities);
    this.unassignedActivities = processedUnassigned.activities;
    this.unassignedRowHeight = processedUnassigned.height;
  }

  processOverlaps(activities: ProjectActivity[]): { activities: ScheduledActivity[], height: number } {
    if (!activities || activities.length === 0) return { activities: [], height: this.minRowHeight };

    const items = activities.map(activity => ({
      activity,
      start: moment(activity.startDate).valueOf(),
      end: moment(activity.endDate).valueOf(),
      rowIndex: 0,
      overlaps: false
    }));

    items.sort((a, b) => {
      const startDiff = a.start - b.start;
      if (startDiff !== 0) return startDiff;
      return b.end - a.end;
    });

    const lanes: number[] = [];

    items.forEach(item => {
      let placed = false;

      for (let i = 0; i < lanes.length; i++) {
        if (lanes[i] <= item.start) {
          lanes[i] = item.end;
          item.rowIndex = i;
          placed = true;
          break;
        }
      }

      if (!placed) {
        lanes.push(item.end);
        item.rowIndex = lanes.length - 1;
      }
    });

    for (let i = 0; i < items.length; i++) {
      const a = items[i];
      for (let j = i + 1; j < items.length; j++) {
        const b = items[j];
        if (b.start >= a.end) break;

        a.overlaps = true;
        b.overlaps = true;
      }
    }

    const result = items.map(i => ({
      activity: i.activity,
      rowIndex: i.rowIndex,
      overlaps: i.overlaps
    }));

    const rowCount = lanes.length;
    const height = Math.max(this.minRowHeight, rowCount * this.rowHeight + 16);

    return { activities: result, height };
  }


  ngAfterViewInit() {
    this.initDragScroll();
    this.checkScrollPosition();
    this.scheduleContent.nativeElement.addEventListener('scroll', () => {
       this.checkScrollPosition();
    });

    document.addEventListener('mousemove', (e: MouseEvent) => {
      // Check for drag start threshold
      if (this.dragStartTimer) {
        const dist = Math.sqrt(Math.pow(e.clientX - this.dragStartXEvent, 2) + Math.pow(e.clientY - this.dragStartYEvent, 2));
        if (dist > 5) {
          clearTimeout(this.dragStartTimer);
          this.dragStartTimer = null;
          this.startDrag(e);
        }
      }

      if (this.isDraggingEvent && this.draggedActivity) {
        this.wasDragging = true;
        this.onEventMouseMove(e);
      }
      if (this.isDraggingUser) {
        this.onUserDragMove(e);
      }
    });

    document.addEventListener('mouseup', (e: MouseEvent) => {
      // Cancel pending drag on mouse up
      if (this.dragStartTimer) {
        clearTimeout(this.dragStartTimer);
        this.dragStartTimer = null;
        this.pendingDragActivity = null;
        this.pendingDragElement = null;
      }

      if (this.isDraggingEvent && this.draggedActivity) {
        this.onEventMouseUp(e);
      }
      if (this.isDraggingUser) {
        this.onUserDragEnd(e);
      }
    });

    document.addEventListener('touchmove', (e: TouchEvent) => {
      if (this.dragStartTimer) {
        const startTouch = e.touches[0];
        const dist = Math.sqrt(Math.pow(startTouch.clientX - this.dragStartXEvent, 2) + Math.pow(startTouch.clientY - this.dragStartYEvent, 2));
        if (dist > 5) {
          clearTimeout(this.dragStartTimer);
          this.dragStartTimer = null;
        }
      }

      const touch = e.touches[0];
      const eventLike = {clientX: touch.clientX, clientY: touch.clientY} as any;

      if (this.isDraggingEvent && this.draggedActivity) {
        e.preventDefault();
        this.wasDragging = true;
        this.onEventMouseMove(eventLike);
      }
      if (this.isDraggingUser) {
        e.preventDefault();
        this.onUserDragMove(eventLike);
      }
    }, {passive: false});

    document.addEventListener('touchend', (e: TouchEvent) => {
      if (this.dragStartTimer) {
        clearTimeout(this.dragStartTimer);
        this.dragStartTimer = null;
        this.pendingDragActivity = null;
        this.pendingDragElement = null;
      }

      const touch = e.changedTouches[0];
      const eventLike = {clientX: touch.clientX, clientY: touch.clientY} as any;

      if (this.isDraggingEvent && this.draggedActivity) {
        this.onEventMouseUp(eventLike);
      }
      if (this.isDraggingUser) {
        this.onUserDragEnd(eventLike);
      }
    });

    document.addEventListener('touchcancel', () => {
      if (this.dragStartTimer) {
        clearTimeout(this.dragStartTimer);
        this.dragStartTimer = null;
        this.pendingDragActivity = null;
        this.pendingDragElement = null;
      }

      if (this.isDraggingEvent && this.draggedActivity) {
        this.resetDrag();
      }
      if (this.isDraggingUser) {
        this.onUserDragEnd({} as any);
      }
    });
  }

  initDragScroll() {
    const container = this.scheduleContent.nativeElement;
    let startY = 0;
    let scrollTop = 0;

    container.addEventListener('mousedown', (e: MouseEvent) => {
      const rect = container.getBoundingClientRect();
      const isVerticalScrollbar = e.clientX > rect.left + container.clientLeft + container.clientWidth;
      const isHorizontalScrollbar = e.clientY > rect.top + container.clientTop + container.clientHeight;

      if (isVerticalScrollbar || isHorizontalScrollbar) {
        return;
      }

      if (this.isSplitMode) {
        const target = e.target as HTMLElement;
        const isEventElement = target.closest('.event-item');

        if (!isEventElement) {
          this.isSplitMode = false;
          this.splitActivity = null;
          this.hoveredSplitGuideIndex = -1;
        }
        return;
      }

      this.isDragging = true;
      this.wasDragging = false;
      this.hasLoadedDuringDrag = false;
      this.startX = e.pageX - container.offsetLeft;
      this.scrollLeft = container.scrollLeft;

      startY = e.pageY - container.offsetTop;
      scrollTop = container.scrollTop;

    });

    container.addEventListener('mouseleave', () => {
      this.isDragging = false;
      this.hasLoadedDuringDrag = false;
      this.checkScrollPosition();
      setTimeout(() => {
        this.wasDragging = false;
      }, 50);
    });

    container.addEventListener('mouseup', () => {
      this.isDragging = false;
      this.hasLoadedDuringDrag = false;
      this.checkScrollPosition();
      setTimeout(() => {
        this.wasDragging = false;
      }, 50);
    });

    container.addEventListener('mousemove', (e: MouseEvent) => {
      if (!this.isDragging) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walkX = (x - this.startX);
      container.scrollLeft = this.scrollLeft - walkX;

      const y = e.pageY - container.offsetTop;
      const walkY = (y - startY);
      container.scrollTop = scrollTop - walkY;

      if (Math.abs(walkX) > 5 || Math.abs(walkY) > 5) {
        this.wasDragging = true;
      }
    });
  }


  checkScrollPosition() {
    const contentScroll = this.scheduleContent.nativeElement;
    const scrollLeft = contentScroll.scrollLeft;
    const scrollWidth = contentScroll.scrollWidth;
    const clientWidth = contentScroll.clientWidth;

    if (this.isDragging || this.isSplitMode) {
      return;
    }

    if (scrollLeft < this.scrollThreshold && !this.loadingPastEvents) {
      this.loadPastActivities();
    }

    if (scrollLeft + clientWidth > scrollWidth - this.scrollThreshold && !this.loadingFutureEvents) {
      this.loadFutureActivities();
    }
  }

  isToday(date: Date): boolean {
    return moment(date).isSame(moment(), 'day');
  }

  isFriday(date: Date): boolean {
    return moment(date).day() === 0;
  }

  isWeekend(date: moment.Moment | Date): boolean {
    const d = moment(date);
    const day = d.day();
    return day === 0 || day === 6;
  }

  getEventPosition(activity: ProjectActivity): { left: number, width: number } {
    const activityStart = moment(activity.startDate);
    const activityEnd = moment(activity.endDate);

    const left = this.diffBusinessDays(this.startDate, activityStart) * this.dayWidth;
    const width = this.diffBusinessDays(activityStart, activityEnd.clone().add(1, 'days')) * this.dayWidth;

    return {
      left,
      width: width - 4 // -4 for margin/padding
    };
  }

  diffBusinessDays(start: moment.Moment | Date, end: moment.Moment | Date): number {
    const s = moment(start).startOf('day');
    const e = moment(end).startOf('day');

    if (s.isSame(e)) return 0;
    if (s.isAfter(e)) return -this.diffBusinessDays(e, s);

    return e.diff(s, 'days');
  }

  getGridStyle() {
    let targetDayOffset = -1;
    for (let i = 0; i < this.days.length; i++) {
        if (moment(this.days[i]).day() === 0) { // Sunday
        targetDayOffset = i;
        break;
        }
    }

    const basicGrid = `linear-gradient(to right, transparent ${this.dayWidth - 1}px, #ddd ${this.dayWidth - 1}px, #ddd ${this.dayWidth}px)`;

    if (targetDayOffset === -1) {
        return {
        'background-image': basicGrid,
        'background-size': `${this.dayWidth}px 100%`
        };
    }

    const weekWidth = 7 * this.dayWidth;
    const offset = (targetDayOffset + 1) * this.dayWidth;

    const weekGrid = `linear-gradient(to right, transparent ${weekWidth - 2}px, #ccc ${weekWidth - 2}px, #ccc ${weekWidth}px)`;

    return {
        'background-image': `${weekGrid}, ${basicGrid}`,
        'background-size': `${weekWidth}px 100%, ${this.dayWidth}px 100%`,
        'background-position': `${offset - weekWidth}px 0, 0 0`,
        'background-repeat': 'repeat'
    };
  }

  getGridBackgroundImage() {
    return `linear-gradient(to right, transparent ${this.dayWidth - 1}px, #eee ${this.dayWidth - 1}px, #eee ${this.dayWidth}px)`;
  }

  getProjectColor(projectId: number): string {
    const hue = (projectId * 0.618033988749895) % 1;
    const saturation = 0.2;
    const value = 0.9;

    let r: number;
    let g: number;
    let b: number;

    const i = Math.floor(hue * 6);
    const f = hue * 6 - i;
    const p = value * (1 - saturation);
    const q = value * (1 - saturation * f);
    const t = value * (1 - saturation * (1 - f));

    switch (i % 6) {
      case 0: r = value; g = t; b = p; break;
      case 1: r = q; g = value; b = p; break;
      case 2: r = p; g = value; b = t; break;
      case 3: r = p; g = q; b = value; break;
      case 4: r = t; g = p; b = value; break;
      case 5: r = value; g = p; b = q; break;
    }

    const toHex = (n: number) => {
      const hex = Math.round(n * 255).toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    };

    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }

  getEventBackgroundStyle(activity: ProjectActivity): any {
    const baseColor = this.getProjectColor(activity.project.id);

    if (activity.ready) {
      return {
        background: `repeating-linear-gradient(135deg, #ffffff7a, #ffffff7a 16px, #FFF1 5px, #FFF1 20px)`,
        'background-color': baseColor
      };
    }

    return {
      'background-color': baseColor
    };
  }

  onEventClick(activity: ProjectActivity, event: MouseEvent) {
    if (this.wasDragging || this.isDraggingEvent) {
      event.stopPropagation();
      return;
    }
    event.stopPropagation();

    const currentTime = Date.now();
    const eventId = activity.id.toString();

    if (this.lastClickedEventId === eventId &&
        (currentTime - this.lastClickTime) < this.doubleClickDelay) {

      if (this.singleClickTimeout) {
        clearTimeout(this.singleClickTimeout);
        this.singleClickTimeout = null;
      }

      if (this.isTablet || this.isMobile) {
        if (this.currentUser.installationUser) {
          this.openLastDrawing(activity);
        } else {
          this.openProjectWindow(activity);
        }
      } else {
        if (this.currentUser.installationUser) {
          this.openLastDrawing(activity);
        } else {
          this.openProjectWindow(activity);
        }
      }

      this.lastClickTime = 0;
      this.lastClickedEventId = null;

      return;
    }

    if (this.singleClickTimeout) {
      clearTimeout(this.singleClickTimeout);
    }

    this.lastClickTime = currentTime;
    this.lastClickedEventId = eventId;

    this.singleClickTimeout = setTimeout(() => {
      this.singleClickTimeout = null;
    }, this.doubleClickDelay);
  }

  onEventTouchStart(activity: ProjectActivity, event: TouchEvent) {
    event.stopPropagation();

    const currentTime = Date.now();
    const eventId = activity.id.toString();

    if (this.lastTouchedEventId === eventId &&
        (currentTime - this.lastTouchTime) < this.doubleClickDelay) {

      event.preventDefault();

      if (this.currentUser.installationUser) {
        this.openLastDrawing(activity);
      } else {
        this.openProjectWindow(activity);
      }

      this.lastTouchTime = 0;
      this.lastTouchedEventId = null;

      return;
    }

    this.lastTouchTime = currentTime;
    this.lastTouchedEventId = eventId;

    const touch = event.touches[0];
    this.dragStartXEvent = touch.clientX;
    this.dragStartYEvent = touch.clientY;

    let eventElement = event.target as HTMLElement;
    if (!eventElement.classList.contains('event-item')) {
      eventElement = eventElement.closest('.event-item') as HTMLElement;
    }

    if (!eventElement) return;

    this.pendingDragElement = eventElement;
    this.pendingDragActivity = activity;

    const rect = eventElement.getBoundingClientRect();
    this.dragOffsetX = touch.clientX - rect.left;
    this.dragOffsetY = touch.clientY - rect.top;

    this.dragStartTimer = setTimeout(() => {
      this.dragStartTimer = null;
      this.startDrag({clientX: this.dragStartXEvent, clientY: this.dragStartYEvent});
    }, 500);
  }

  onEventMouseDown(activity: ProjectActivity, event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();

    this.dragStartXEvent = event.clientX;
    this.dragStartYEvent = event.clientY;

    let eventElement = event.target as HTMLElement;
    if (!eventElement.classList.contains('event-item')) {
      eventElement = eventElement.closest('.event-item') as HTMLElement;
    }

    this.pendingDragElement = eventElement;
    this.pendingDragActivity = activity;

    const rect = eventElement.getBoundingClientRect();
    this.dragOffsetX = event.clientX - rect.left;
    this.dragOffsetY = event.clientY - rect.top;

    this.dragStartTimer = setTimeout(() => {
      this.dragStartTimer = null;
      this.startDrag({clientX: this.dragStartXEvent, clientY: this.dragStartYEvent});
    }, 200);
  }

  startDrag(eventLike: {clientX: number, clientY: number}) {
    if (!this.pendingDragActivity || !this.pendingDragElement) {
      return;
    }

    this.draggedActivity = this.pendingDragActivity;
    this.isDraggingEvent = true;
    this.wasDragging = false;

    const eventElement = this.pendingDragElement;
    this.draggedOriginalElement = eventElement;
    eventElement.style.opacity = '0.1';

    const activity = this.draggedActivity;
    if (activity.user && activity.user.id) {
      this.draggedOriginalUser = this.users.find(u => u.id === activity.user.id);
    } else {
      this.draggedOriginalUser = null;
    }

    this.createDragPreview(eventElement, eventLike);

    document.body.style.cursor = 'grabbing';

    this.pendingDragActivity = null;
    this.pendingDragElement = null;
  }

  createDragPreview(originalElement: HTMLElement, event: any) {
    const clone = originalElement.cloneNode(true) as HTMLElement;
    clone.classList.add('drag-preview');
    clone.style.width = originalElement.offsetWidth + 'px';
    clone.style.height = originalElement.offsetHeight + 'px';
    clone.style.left = (event.clientX - this.dragOffsetX) + 'px';
    clone.style.top = (event.clientY - this.dragOffsetY) + 'px';
    clone.style.opacity = '0.8';

    document.body.appendChild(clone);
    this.dragPreviewElement = clone;
    this.dragPreviewX = event.clientX - this.dragOffsetX;
    this.dragPreviewY = event.clientY - this.dragOffsetY;
  }

  openProjectWindow(activity: ProjectActivity): void {
    let projectWindow = ProjectWindowComponent as any;

    let panelClass = 'project-window-dialog'

    if (this.isMobile || this.isTablet) {
      projectWindow = ProjectInfoComponent
      panelClass = 'project-info-dialog'
    }

    const dialogRef = this.dialog.open(projectWindow, {
      data: {
        projectNumber: activity.project.id,
      },
      panelClass
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadActivities();
    });
  }

  openLastDrawing(activity: ProjectActivity): void {
    const projectId = activity.project.id

    this.dialog.open(PdfPreviewDialogComponent, {
      data: {
        dialogHeader: activity.project.name,
        link: '/project/' + projectId + '/files/last-drawing',
        showSendButton: true
      },
      panelClass: 'pdf-preview-dialog'
    });
  }

  showHint(activity: ProjectActivity, event: MouseEvent) {
    this.activityInHint = activity;
    this.eventHintOP.show(null, event.target);
  }

  hideHint() {
    this.eventHintOP.hide();
  }

  onEventMouseMove(event: MouseEvent) {
    if (!this.dragPreviewElement) return;

    this.dragPreviewX = event.clientX - this.dragOffsetX;
    this.dragPreviewY = event.clientY - this.dragOffsetY;

    this.dragPreviewElement.style.left = this.dragPreviewX + 'px';
    this.dragPreviewElement.style.top = this.dragPreviewY + 'px';

    if (this.deleteDropArea && this.deleteDropArea.nativeElement) {
      const deleteRect = this.deleteDropArea.nativeElement.getBoundingClientRect();
      const isOver = event.clientX >= deleteRect.left && event.clientX <= deleteRect.right &&
                     event.clientY >= deleteRect.top && event.clientY <= deleteRect.bottom;
      this.isOverDeleteArea = isOver;

      if (isOver) {
        this.highlightedDayIndex = -1;
        this.highlightedUserId = -1;
        this.highlightedUnassigned = false;
        this.stopAutoScroll();
        return;
      }
    }

    const container = this.scheduleContent.nativeElement;
    const containerRect = container.getBoundingClientRect();
    const scrollLeft = container.scrollLeft;
    const scrollTop = container.scrollTop;
    const userColumnWidth = 200;
    const headerHeight = 60;

    const edgeThreshold = 100;
    const maxScrollSpeed = 20;

    if (event.clientX >= containerRect.left && event.clientX <= containerRect.right &&
        event.clientY >= containerRect.top && event.clientY <= containerRect.bottom) {

      const previewLeftEdge = this.dragPreviewX;
      const relativeX = previewLeftEdge - containerRect.left + scrollLeft;
      const dayIndex = Math.floor((relativeX - userColumnWidth) / this.dayWidth);

      if (dayIndex >= 0 && dayIndex < this.days.length) {
        this.highlightedDayIndex = dayIndex;
      } else {
        this.highlightedDayIndex = -1;
      }

      const relativeY = event.clientY - containerRect.top + scrollTop;

      if (relativeY >= headerHeight) {
        let currentY = headerHeight;
        let foundUser = false;

        for (const user of this.users) {
          const rowHeight = this.userRowHeights.get(user.id) || this.minRowHeight;
          if (relativeY >= currentY && relativeY < currentY + rowHeight) {
            this.highlightedUserId = user.id;
            this.highlightedUnassigned = false;
            foundUser = true;
            break;
          }
          currentY += rowHeight;
        }

        if (!foundUser && this.showUnassigned) {
          if (relativeY >= currentY && relativeY < currentY + this.unassignedRowHeight) {
            this.highlightedUserId = -1;
            this.highlightedUnassigned = true;
          } else {
            this.highlightedUserId = -1;
            this.highlightedUnassigned = false;
          }
        } else if (!foundUser) {
          this.highlightedUserId = -1;
          this.highlightedUnassigned = false;
        }
      } else {
        this.highlightedUserId = -1;
        this.highlightedUnassigned = false;
      }

      const distanceFromLeft = event.clientX - containerRect.left;
      const distanceFromRight = containerRect.right - event.clientX;

      if (distanceFromLeft < edgeThreshold + userColumnWidth) {
        if (distanceFromLeft <= userColumnWidth) {
          this.autoScrollSpeed = -maxScrollSpeed;
        } else {
          const ratio = 1 - (distanceFromLeft - userColumnWidth) / edgeThreshold;
          this.autoScrollSpeed = -Math.max(5, ratio * maxScrollSpeed);
        }
        this.startAutoScroll();
      } else if (distanceFromRight < edgeThreshold + userColumnWidth) {
        const ratio = 1 - distanceFromRight / (edgeThreshold + userColumnWidth);
        this.autoScrollSpeed = Math.max(5, ratio * maxScrollSpeed);
        this.startAutoScroll();
      } else {
        this.stopAutoScroll();
      }
    } else {
      this.highlightedDayIndex = -1;
      this.highlightedUserId = -1;
      this.highlightedUnassigned = false;
      this.stopAutoScroll();
    }
  }

  startAutoScroll() {
    if (this.autoScrollInterval) return;

    this.autoScrollInterval = setInterval(() => {
      const container = this.scheduleContent.nativeElement;
      container.scrollLeft += this.autoScrollSpeed;
      this.checkScrollPosition();
    }, 16);
  }

  stopAutoScroll() {
    if (this.autoScrollInterval) {
      clearInterval(this.autoScrollInterval);
      this.autoScrollInterval = null;
    }
    this.autoScrollSpeed = 0;
  }

  onEventMouseUp(event: MouseEvent) {
    if (!this.draggedActivity) {
      return;
    }

    if (this.isOverDeleteArea) {
      this.onDeleteAreaDrop(event);
      return;
    }

    const container = this.scheduleContent.nativeElement;
    const containerRect = container.getBoundingClientRect();

    const clientX = event.clientX;
    const clientY = event.clientY;

    if (clientX < containerRect.left || clientX > containerRect.right ||
        clientY < containerRect.top || clientY > containerRect.bottom) {
      this.resetDrag();
      return;
    }

    const scrollLeft = container.scrollLeft;
    const scrollTop = container.scrollTop;

    const previewLeftEdge = this.dragPreviewX;
    const relativeX = previewLeftEdge - containerRect.left + scrollLeft;
    const relativeY = clientY - containerRect.top + scrollTop;

    const headerHeight = 60;
    const userColumnWidth = 200;

    if (relativeY < headerHeight || relativeX < userColumnWidth) {
      this.resetDrag();
      return;
    }

    const dayIndex = Math.floor((relativeX - userColumnWidth) / this.dayWidth);
    if (dayIndex < 0 || dayIndex >= this.days.length) {
      this.resetDrag();
      return;
    }

    const newStartDate = moment(this.days[dayIndex]).startOf('day');

    let targetUser: User | null = null;
    let currentY = headerHeight;
    let isUnassignedRow = false;

    for (const user of this.users) {
      const rowHeight = this.userRowHeights.get(user.id) || this.minRowHeight;
      if (relativeY >= currentY && relativeY < currentY + rowHeight) {
        targetUser = user;
        break;
      }
      currentY += rowHeight;
    }

    if (!targetUser && this.showUnassigned) {
      if (relativeY >= currentY && relativeY < currentY + this.unassignedRowHeight) {
        targetUser = null;
        isUnassignedRow = true;
      }
    }

    if (!targetUser && !isUnassignedRow) {
      this.resetDrag();
      return;
    }

    const originalStartDate = moment(this.draggedActivity.startDate);
    const originalEndDate = moment(this.draggedActivity.endDate);
    const originalUserId = this.draggedActivity.user?.id || null;
    const newUserId = targetUser?.id || null;

    const dateChanged = !originalStartDate.isSame(newStartDate, 'day');
    const userChanged = originalUserId !== newUserId;

    if (dateChanged || userChanged) {
      const updatedActivity: any = {
        id: this.draggedActivity.id
      };

      if (dateChanged) {
        const durationDays = originalEndDate.diff(originalStartDate, 'days');
        const newEndDate = moment(newStartDate).add(durationDays, 'days').endOf('day');

        updatedActivity.startDate = newStartDate.toDate();
        updatedActivity.endDate = newEndDate.toDate();
      }

      if (userChanged) {
        updatedActivity.user = targetUser ? {
          id: targetUser.id
        } : null;
      }

      const activityToUpdate = this.activities.find(a => a.id === this.draggedActivity.id);
      if (activityToUpdate) {
        if (dateChanged) {
          const durationDays = originalEndDate.diff(originalStartDate, 'days');
          const newEndDate = moment(newStartDate).add(durationDays, 'days').endOf('day');

          activityToUpdate.startDate = newStartDate.toDate();
          activityToUpdate.endDate = newEndDate.toDate();
        }
        if (userChanged) {
          activityToUpdate.user = targetUser;
        }
      }

      this.distributeActivities();
      this.resetDrag();

      this.projectActivityService.saveProjectActivity(updatedActivity).subscribe(
        () => {
          this.loadActivities();
        },
        (error) => {
          this.miscSnackBarService.openErrorSnackBar(error.message);
          this.loadActivities();
        }
      );
    } else {
      this.resetDrag();
    }
  }

  resetDrag() {
    this.stopAutoScroll();

    if (this.dragPreviewElement) {
      document.body.removeChild(this.dragPreviewElement);
      this.dragPreviewElement = null;
    }

    if (this.draggedOriginalElement) {
      this.draggedOriginalElement.style.opacity = '';
      this.draggedOriginalElement = null;
    }

    this.highlightedDayIndex = -1;
    this.highlightedUserId = -1;
    this.highlightedUnassigned = false;
    this.draggedActivity = null;
    this.draggedOriginalUser = null;
    this.isDraggingEvent = false;
    this.isOverDeleteArea = false;
    document.body.style.cursor = '';
    setTimeout(() => {
      this.wasDragging = false;
    }, 50);
  }

  onDeleteAreaEnter() {
    this.isOverDeleteArea = true;
  }

  onDeleteAreaLeave() {
    this.isOverDeleteArea = false;
  }

  onDeleteAreaDrop(event: MouseEvent) {
    event.stopPropagation();

    if (!this.draggedActivity || !this.isDraggingEvent) {
      return;
    }

    const activityId = this.draggedActivity.id;
    this.resetDrag();

    this.projectActivityService.deleteProjectActivities(activityId).subscribe(
      () => {
        this.loadActivities();
      },
      (error) => {
        this.miscSnackBarService.openErrorSnackBar(error.message);
        this.loadActivities();
      }
    );
  }

  ngOnDestroy() {
    if (this.wsSocketSub) {
      this.wsSocketSub.unsubscribe()
      this.wsSocketSub = null;
    }
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }

  wsSub() {
    this.wsSocketSub = this.wsService
      .listenUntilDestroyed<WsUpdateResponce<ShortProject>>('/topic/update/model.project.Project', this)
      .subscribe(() => {
        this.loadActivities();
      })
  }

  trackByActivityId(index: number, item: ScheduledActivity): string {
    const userId = item.activity.user?.id || 0;
    return `${item.activity.id}-${userId}`;
  }

  trackByUserId(index: number, user: User): number {
    return user.id;
  }

  trackByDayIndex(index: number, day: Date): number {
    return day.getTime();
  }

  toggleSplitMode() {
    this.isSplitMode = !this.isSplitMode;
    if (!this.isSplitMode) {
      this.splitActivity = null;
      this.hoveredSplitGuideIndex = -1;
    }
  }

  hasMultipleUsers(activity: ProjectActivity): boolean {
    const activities = this.activityIdMap.get(activity.id);
    return activities && activities.length > 1;
  }

  onChainIconClick(activity: ProjectActivity, event: MouseEvent) {
    event.stopPropagation();
    const activities = this.activityIdMap.get(activity.id);
    if (!activities || activities.length <= 1) return;

    const activityElements = document.querySelectorAll(`[data-activity-id="${activity.id}"]`);
    activityElements.forEach(el => {
      (el as HTMLElement).classList.add('chain-highlight');
    });

    setTimeout(() => {
      activityElements.forEach(el => {
        (el as HTMLElement).classList.remove('chain-highlight');
      });
    }, 700);
  }

  onAddActivityClick(activity: ProjectActivity, event: MouseEvent) {
    event.stopPropagation();

    const startDate = moment(activity.endDate).add(1, 'days').startOf('day').toDate();
    const duration = 8 * 3600;

    const newActivity = Object.assign(new ProjectActivity(), {
      startDate,
      duration,
      user: activity.user,
      ignoreTime: activity.ignoreTime
    });

    this.projectActivityService.createProjectActivity(activity.project.id, activity.type.name, newActivity).subscribe(
      () => {
        this.loadActivities();
      },
      (error) => {
        this.miscSnackBarService.openErrorSnackBar(error.message);
      }
    );
  }

  canSplitActivity(activity: ProjectActivity): boolean {
    const activityStart = moment(activity.startDate).startOf('day');
    const activityEnd = moment(activity.endDate).startOf('day');
    const durationDays = activityEnd.diff(activityStart, 'days');
    return durationDays >= 1;
  }

  onEventClickSplitMode(activity: ProjectActivity, event: MouseEvent) {
    event.stopPropagation();

    if (this.hoveredSplitGuideIndex >= 0) {
      const activityStart = moment(activity.startDate).startOf('day');
      const activityEnd = moment(activity.endDate).startOf('day');
      const durationDays = activityEnd.diff(activityStart, 'days');

      if (durationDays < 1) {
        this.miscSnackBarService.openErrorSnackBar('Cannot split an event that is less than 2 days long');
        return;
      }

      const clickedDate = moment(this.days[this.hoveredSplitGuideIndex]).startOf('day');
      const splitDate = clickedDate.subtract(1, 'day').format('YYYY-MM-DD');

      this.projectActivityService.splitActivity(activity.id, splitDate).subscribe(
        () => {
          this.hoveredSplitGuideIndex = -1;
          this.isSplitMode = false;
          this.loadActivities();
        },
        (error) => {
          this.miscSnackBarService.openErrorSnackBar(error.message);
        }
      );
    }
  }

  onDayCellClickSplitMode(dayIndex: number, event: MouseEvent) {
    if (!this.splitActivity) return;
    event.stopPropagation();

    const clickedDate = moment(this.days[dayIndex]).startOf('day');
    const activityStart = moment(this.splitActivity.startDate).startOf('day');
    const activityEnd = moment(this.splitActivity.endDate).startOf('day');

    if (clickedDate.isSameOrBefore(activityStart) || clickedDate.isAfter(activityEnd)) {
      return;
    }

    const splitDate = clickedDate.format('YYYY-MM-DD');

    this.projectActivityService.splitActivity(this.splitActivity.id, splitDate).subscribe(
      () => {
        this.splitActivity = null;
        this.loadActivities();
      },
      (error) => {
        this.miscSnackBarService.openErrorSnackBar(error.message);
      }
    );
  }

  isEventInSplitMode(activity: ProjectActivity): boolean {
    return this.isSplitMode && this.splitActivity && this.splitActivity.id === activity.id;
  }

  getSplitGuides(activity: ProjectActivity): Array<{position: number, dayIndex: number}> {
    if (!this.canSplitActivity(activity)) return [];

    const activityStart = moment(activity.startDate).startOf('day');
    const activityEnd = moment(activity.endDate).startOf('day');
    const durationDays = activityEnd.diff(activityStart, 'days');

    if (durationDays < 1) return [];

    const guides = [];
    const scheduleStartDate = moment(this.startDate).startOf('day');

    for (let i = 1; i <= durationDays; i++) {
      const guideDate = moment(activityStart).add(i, 'days').startOf('day');
      const dayIndexInSchedule = this.days.findIndex(d => moment(d).isSame(guideDate, 'day'));

      if (dayIndexInSchedule >= 0) {
        const daysFromActivityStart = guideDate.diff(activityStart, 'days');
        const activityStartDaysFromSchedule = activityStart.diff(scheduleStartDate, 'days');
        const position = (activityStartDaysFromSchedule + daysFromActivityStart) * this.dayWidth - activityStartDaysFromSchedule * this.dayWidth;
        guides.push({ position, dayIndex: dayIndexInSchedule });
      }
    }

    return guides;
  }

  onSplitEventMouseMove(activity: ProjectActivity, event: MouseEvent) {
    if (!this.canSplitActivity(activity)) return;

    const eventElement = event.currentTarget as HTMLElement;
    const rect = eventElement.getBoundingClientRect();
    const relativeX = event.clientX - rect.left;

    const guides = this.getSplitGuides(activity);
    let closestGuide = -1;
    let minDistance = Infinity;

    guides.forEach(guide => {
      const distance = Math.abs(relativeX - guide.position);
      if (distance < minDistance && distance < this.snapThreshold) {
        minDistance = distance;
        closestGuide = guide.dayIndex;
      }
    });

    this.hoveredSplitGuideIndex = closestGuide;
  }

  onSplitEventMouseLeave() {
    this.hoveredSplitGuideIndex = -1;
    this.hideHint();
  }

  isDayBorderForSplitEvent(dayIndex: number): boolean {
    if (!this.isSplitMode || !this.splitActivity) return false;

    const dayDate = moment(this.days[dayIndex]).startOf('day');
    const activityStart = moment(this.splitActivity.startDate).startOf('day');
    const activityEnd = moment(this.splitActivity.endDate).startOf('day');

    if (dayDate.isSameOrBefore(activityStart) || dayDate.isAfter(activityEnd)) {
      return false;
    }

    return true;
  }

  onUserDragStart(user: User, index: number, event: MouseEvent) {
    if (this.isSplitMode) return;

    event.stopPropagation();
    event.preventDefault();
    this.isDraggingUser = true;
    this.draggedUser = user;
    this.draggedUserIndex = index;

    const target = event.currentTarget as HTMLElement;
    const userCell = target.closest('.user-cell-wrapper') as HTMLElement;
    const userRow = target.closest('.body-row') as HTMLElement;

    if (userCell && userRow) {
      this.draggedOriginalElement = userRow;
      userRow.style.opacity = '0';
      this.draggedUserHeight = userRow.offsetHeight;

      const rect = userRow.getBoundingClientRect();
      this.dragOffsetX = event.clientX - rect.left;
      this.dragOffsetY = event.clientY - rect.top;

      this.createUserDragPreview(userRow, event);
    }

    document.body.style.cursor = 'grabbing';
  }

  onUserTouchStart(user: User, index: number, event: TouchEvent) {
    if (this.isSplitMode) return;

    event.stopPropagation();
    // Don't prevent default immediately to allow scrolling if needed,
    // but here we are dragging so we likely want to prevent scroll.
    event.preventDefault();

    this.isDraggingUser = true;
    this.draggedUser = user;
    this.draggedUserIndex = index;

    const target = event.currentTarget as HTMLElement;
    const userCell = target.closest('.user-cell-wrapper') as HTMLElement;
    const userRow = target.closest('.body-row') as HTMLElement;

    if (userCell && userRow) {
      this.draggedOriginalElement = userRow;
      userRow.style.opacity = '0';
      this.draggedUserHeight = userRow.offsetHeight;

      const touch = event.touches[0];
      const rect = userRow.getBoundingClientRect();
      this.dragOffsetX = touch.clientX - rect.left;
      this.dragOffsetY = touch.clientY - rect.top;

      this.createUserDragPreview(userRow, {
        clientX: touch.clientX,
        clientY: touch.clientY
      } as any);
    }

    document.body.style.cursor = 'grabbing';
  }

  createUserDragPreview(element: HTMLElement, event: any) {
    const clone = element.cloneNode(true) as HTMLElement;
    clone.classList.add('user-drag-preview');

    const rect = element.getBoundingClientRect();
    clone.style.width = rect.width + 'px';
    clone.style.height = rect.height + 'px';
    clone.style.left = rect.left + 'px';
    clone.style.top = (event.clientY - this.dragOffsetY) + 'px';
    clone.style.opacity = '0.9';

    document.body.appendChild(clone);
    this.userDragPreviewElement = clone;
  }

  onUserDragMove(event: MouseEvent) {
    if (!this.isDraggingUser || !this.userDragPreviewElement) return;

    this.userDragPreviewElement.style.top = (event.clientY - this.dragOffsetY) + 'px';

    const container = this.scheduleContent.nativeElement;
    const containerRect = container.getBoundingClientRect();
    const scrollTop = container.scrollTop;
    const headerHeight = 60;

    if (event.clientY < containerRect.top + headerHeight) {
      this.dropTargetUserIndex = 0;
      this.animateUserRows();
      return;
    }

    if (event.clientY > containerRect.bottom) {
      this.dropTargetUserIndex = this.users.length - 1;
      this.animateUserRows();
      return;
    }

    const relativeY = event.clientY - containerRect.top + scrollTop;

    if (relativeY < headerHeight) {
      this.dropTargetUserIndex = 0;
      this.animateUserRows();
      return;
    }

    let currentY = headerHeight;
    let foundIndex = -1;

    for (let i = 0; i < this.users.length; i++) {
      const user = this.users[i];
      const rowHeight = this.userRowHeights.get(user.id) || this.minRowHeight;

      if (relativeY >= currentY && relativeY < currentY + rowHeight) {
        foundIndex = i;
        break;
      }
      currentY += rowHeight;
    }

    if (foundIndex === -1) {
      foundIndex = this.users.length - 1;
    }

    this.dropTargetUserIndex = foundIndex;
    this.animateUserRows();
  }

  animateUserRows() {
    const userRows = this.scheduleContent.nativeElement.querySelectorAll('.body-row:not(.unassigned-row)');

    for (let i = 0; i < userRows.length; i++) {
      const row = userRows[i] as HTMLElement;

      if (i === this.draggedUserIndex) {
        row.style.transform = '';
        continue;
      }

      let translateY = 0;

      if (this.dropTargetUserIndex !== -1) {
        if (this.draggedUserIndex < this.dropTargetUserIndex) {
          if (i > this.draggedUserIndex && i <= this.dropTargetUserIndex) {
            translateY = -this.draggedUserHeight;
          }
        } else if (this.draggedUserIndex > this.dropTargetUserIndex) {
          if (i >= this.dropTargetUserIndex && i < this.draggedUserIndex) {
            translateY = this.draggedUserHeight;
          }
        }
      }

      if (translateY !== 0) {
        row.style.transform = `translateY(${translateY}px)`;
      } else {
        row.style.transform = '';
      }
    }
  }

  clearUserRowAnimations() {
       const userRows = this.scheduleContent.nativeElement.querySelectorAll('.body-row');
       userRows.forEach((row: HTMLElement) => {
           row.style.transition = 'unset';
           row.style.transform = '';
       });

       setTimeout(() => {
         userRows.forEach((row: HTMLElement) => {
           row.style.transition = 'transform 0.12s ease';
         });
       }, 130)
  }

  onUserDragEnd(event: MouseEvent) {
    if (!this.isDraggingUser) return;

    this.clearUserRowAnimations();

    if (this.userDragPreviewElement) {
      document.body.removeChild(this.userDragPreviewElement);
      this.userDragPreviewElement = null;
    }

    if (this.draggedOriginalElement) {
      this.draggedOriginalElement.style.opacity = '';
      this.draggedOriginalElement = null;
    }

    if (this.dropTargetUserIndex >= 0 && this.dropTargetUserIndex !== this.draggedUserIndex) {
      const newUsers = [...this.users];
      const [movedUser] = newUsers.splice(this.draggedUserIndex, 1);
      newUsers.splice(this.dropTargetUserIndex, 0, movedUser);

      this.users = newUsers;
      this.updateUserPositions();
    }

    this.isDraggingUser = false;
    this.draggedUser = null;
    this.draggedUserIndex = -1;
    this.dropTargetUserIndex = -1;
    document.body.style.cursor = '';
  }

  updateUserPositions() {
    const userPositions = this.users.map((user, index) => ({
      userId: user.id,
      position: index
    }));

    this.usersService.updateUserPositions(userPositions).subscribe(
      (updatedUsers) => {
        updatedUsers.forEach(updatedUser => {
          const user = this.users.find(u => u.id === updatedUser.id);
          if (user) {
            user.installationPosition = updatedUser.installationPosition;
          }
          const cachedUser = this.allUsersCache.find(u => u.id === updatedUser.id);
          if (cachedUser) {
            cachedUser.installationPosition = updatedUser.installationPosition;
          }
        });
        this.distributeActivities();
      },
      (error) => {
        this.miscSnackBarService.openErrorSnackBar(error.message);
        this.applyUserFilter();
      }
    );
  }
}


















































